export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[!@#$%^&*()_+}{":;'?/>.<,])(?=.*[a-zA-Z]).{6,}$/;

export const PASSWORD_PATTERN_MESSAGE = 
  'Password must be at least 6 characters and contain at least one number, one special character, and one letter';
